import React from 'react';

function Header({ navItems, mobileMenuOpen, setMobileMenuOpen, scrollToSection }) {
  const navigate = (event, id) => {
    event.preventDefault();
    scrollToSection(id);
    setMobileMenuOpen(false);
  };

  return (
    <header className="site-header">
      <nav className="nav" aria-label="Ana navigasyon">
        <a className="brand" href="#home" onClick={(event) => navigate(event, 'home')}>
          Müge Tüfekçi
        </a>
        <button
          className="menu-toggle"
          type="button"
          aria-label={mobileMenuOpen ? 'Menüyü kapat' : 'Menüyü aç'}
          aria-expanded={mobileMenuOpen}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span />
          <span />
          <span />
        </button>
        <div className={`nav-links ${mobileMenuOpen ? 'open' : ''}`}>
          {navItems
            .filter((item) => item.id === 'about' || item.id === 'services')
            .map((item) => (
              <a key={item.id} href={`#${item.id}`} onClick={(event) => navigate(event, item.id)}>
                {item.label}
              </a>
            ))}
          <a
            className="instagram-link"
            href="https://www.instagram.com/uzm.psk.mugetufekci/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              />
              <circle
                cx="12"
                cy="12"
                r="4"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              />
              <circle cx="17.5" cy="6.5" r="1.3" fill="currentColor" />
            </svg>
          </a>
          <a className="nav-cta" href="#contact" onClick={(event) => navigate(event, 'contact')}>
            İletişim
          </a>
        </div>
      </nav>
    </header>
  );
}

export default Header;
